import React from 'react'

// Global announcer — call announce() from anywhere to push a message to screen readers
let _setMessage: ((msg: string) => void) | null = null

export function announce(message: string): void {
  _setMessage?.(message)
}

export function A11yAnnouncer(): React.ReactElement {
  const [message, setMessage] = React.useState('')
  React.useEffect(() => {
    _setMessage = setMessage
    return () => { _setMessage = null }
  }, [])
  // Clear after 3s so the same message can be re-announced
  React.useEffect(() => {
    if (!message) return
    const t = setTimeout(() => setMessage(''), 3000)
    return () => clearTimeout(t)
  }, [message])
  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  )
}
